export enum AppConfigsActionDispatchTypes {
  APP_CONFIG_INVOKE = "APP_CONFIG_INVOKE",
  APP_CONFIG_SUCCESS = "APP_CONFIG_SUCCESS",
  APP_CONFIG_ERROR = "APP_CONFIG_ERROR",
}

export enum AppEnvironmentConfig {
  DEV = "development",
  PROD = "production",
}

export enum CloudEnvironmentConfig {
  DEV1 = "DEV1",
  QA1 = "QA1",
  DEV2 = "DEV2",
  QA2 = "QA2",
}

export enum DownloadUrl {
  PRIOR_AUTHORIZATION_REQUEST = "PRIOR_AUTHORIZATION_REQUEST",
  REFERRAL_FORM_NEVADA_ONLY = "REFERRAL_FORM_NEVADA_ONLY",
  CENTENE_AMBETTER_PA_PA_REQUEST_FORM = "CENTENE_AMBETTER_PA_PA_REQUEST_FORM",
  RESUMPTION_OF_CARE_REQUEST_FORM = "RESUMPTION_OF_CARE_REQUEST_FORM",
  RE_AUTHORIZATION_REQUEST_FORM = "RE_AUTHORIZATION_REQUEST_FORM",
  START_OF_CARE_CONFIRMATION_FORM = "START_OF_CARE_CONFIRMATION_FORM",
  FAX_CONFIRMATION_FORM = "FAX_CONFIRMATION_FORM",
  OUT_OF_NETWORK_SERVICE_NOTIFICATION = "OUT_OF_NETWORK_SERVICE_NOTIFICATION",
  ELECTRONICS_FUNDS_TRANSFER_ENROLLMENT = "ELECTRONICS_FUNDS_TRANSFER_ENROLLMENT",
  CLAIMS_DISPUTE = "CLAIMS_DISPUTE",
  INFORMATION_CHANGE_FORM = "INFORMATION_CHANGE_FORM",
  PROVIDER_MANUAL = "PROVIDER_MANUAL",
  OASIS_UPLOAD = "OASIS_UPLOAD",
  MANAGED_HEALTH_PLAN_LIST = "MANAGED_HEALTH_PLAN_LIST",
}